customElements.define('cart-items', class CartItems extends HTMLElement {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-outer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-outer',
        section: 'cart-summary',
        selector: '.cart__summary-outer'
      },
      {
        id: 'cart-drawer',
        section: 'cart-items',
        selector: '.cart__cart-items'
      },
      {
        id: 'cart-drawer',
        section: 'cart-footer',
        selector: '.cart-drawer__footer'
      },
      {
        id: 'nav-inner',
        section: 'cart-nav-icon',
        selector: '.nav__link--cart'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateQuantity(line, quantity, newProperties = {}) {
    this.querySelector('.cart-item__qty').classList.add('disabled');
    fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            line: line,
            quantity: quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        })
    })
    .then((response) => response.json())
    .then((response) => {
      this.getSectionsToRender().forEach((section => {
        if (document.getElementById(section.id) != null && document.getElementById(section.id).querySelector(section.selector) != null || document.getElementById(section.id) != null) {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
        }
      }))
    })
   .catch((e) => {
      this.querySelectorAll('.loader-container').forEach((loader) => {
        loader.classList.remove('loading');
      });
      console.error(e);
    })
  }
});

customElements.define('cart-remove-button', class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
      cartItem = this.closest('.cart-item');
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.dataset.index, 0, {});
    });
  }
});

customElements.define('cart-quantity', class CartQuantity extends HTMLElement {
  constructor() {
    super();
    this.querySelector('.quantity__input').addEventListener('change', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.querySelector('.quantity__input').value;

      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.dataset.index, quantity, {});
    });
  }
});

customElements.define('quantity-decrease-button', class QuantityDecreaseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.closest('.quantity__btn-container').querySelector('.quantity__input').value;
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.closest('cart-quantity').dataset.index, quantity, {});
    });
  }
});

customElements.define('quantity-increase-button', class QuantityIncreaseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      var cartItems = this.closest('cart-items'),
          cartItem = this.closest('.cart-item'),
          quantity = this.closest('.quantity__btn-container').querySelector('.quantity__input').value;
      
      cartItems.classList.add('disabled');
      cartItem.querySelector('.loader-container').classList.add('loading');
      cartItems.updateQuantity(this.closest('cart-quantity').dataset.index, quantity, {});
    });
  }
});